import React, { HTMLProps } from 'react';
import classnames from 'classnames';

export const racingIconDictionary = [
	{ id: 1, name: 'Gallop', iconName: 'gallop' },
	{ id: 2, name: 'Greyhounds', iconName: 'greyhound' },
	{ id: 3, name: 'Harness', iconName: 'harness' },
];

export const sportIconDictionary = [
	{
		id: 1,
		name: 'Racing',
		iconName: 'gallop',
	},
	{
		id: 2,
		name: 'Soccer',
		iconName: 'football',
	},
	{
		id: 3,
		name: 'Basketball',
		iconName: 'basketball',
	},
	{
		id: 4,
		name: 'American Football',
		iconName: 'nfl',
	},
	{
		id: 5,
		name: 'Australian AFL',
		iconName: 'afl',
	},
	{
		id: 6,
		name: 'Baseball',
		iconName: 'baseball',
	},
	{
		id: 7,
		name: 'Handball',
		iconName: 'uniE95B',
	},
	{
		id: 8,
		name: 'Ice Hockey',
		iconName: 'ice-hockey',
	},
	{
		id: 9,
		name: 'Rugby League',
		iconName: 'uniE954',
	},
	{
		id: 10,
		name: 'Rugby Union',
		iconName: 'rugby-union',
	},
	{
		id: 11,
		name: 'Volleyball',
		iconName: 'volleyball',
	},
	{
		id: 12,
		name: 'Darts',
		iconName: 'darts',
	},
	{
		id: 13,
		name: 'Boxing',
		iconName: 'boxing',
	},
	{
		id: 14,
		name: 'Cricket',
		iconName: 'cricket',
	},
	{
		id: 15,
		name: 'Snooker',
		iconName: 'snooker',
	},
	{
		id: 16,
		name: 'Tennis',
		iconName: 'tennis',
	},
	{
		id: 17,
		name: 'Manual Sport',
		iconName: 'stadium',
	},
	{
		id: 18,
		name: 'Gaelic Football',
		iconName: 'gaelic-sports',
	},
	{
		id: 19,
		name: 'Gaelic Hurling',
		iconName: 'gaelic-sports',
	},
	{
		id: 20,
		name: 'Formula One',
		iconName: 'uniE90A',
	},
	{
		id: 21,
		name: 'Tennis Doubles',
		iconName: 'tennis',
	},
	{
		id: 22,
		name: 'Test Cricket',
		iconName: 'cricket',
	},
	{
		id: 23,
		name: 'Badminton',
		iconName: 'badminton',
	},
	{
		id: 24,
		name: 'Golf',
		iconName: 'golf',
	},

	{
		id: 25,
		name: 'Mixed Martial Arts',
		iconName: 'mma',
	},
	{
		id: 26,
		name: 'Table Tennis',
		iconName: 'table-tennis',
	},
];

type Sport = {
	competitions?: { data: Array<SportCompetition> };
	featured: boolean;
	featured_order: number | null;
	icon: string | null;
	id: number;
	name: string;
	type: 'sports';
	has_sgm: boolean;
};
type SportCompetition = {
	featured?: boolean;
	featured_order: number;
	has_sgm: boolean;
	id: string;
	name: string;
	order: number;
	start_time: string | null;
	type: 'competitions';
};

type Props = {
	iconName: string;
} & HTMLProps<HTMLSpanElement>;

const FontIcon: React.FC<Props> = ({ iconName, className, ...rest }) => (
	<span {...rest} className={classnames(`icon-${iconName}`, className)} />
);

export const RacingIcon: React.FC<{ raceTypeId: number } & HTMLProps<HTMLSpanElement>> = ({ raceTypeId, ...rest }) => (
	<MappedIcon {...rest} typeId={raceTypeId} category="racing" />
);

export const SportIcon: React.FC<{ sportIcon?: Sport['icon']; sportId: number } & HTMLProps<HTMLSpanElement>> = ({
	sportIcon,
	sportId,
	...rest
}) =>
	sportIcon ? <FontIcon iconName={sportIcon} {...rest} /> : <MappedIcon {...rest} typeId={sportId} category="sport" />;

export const MappedIcon: React.FC<{ category: 'sport' | 'racing'; typeId: number } & HTMLProps<HTMLSpanElement>> = ({
	category,
	typeId,

	...rest
}) => {
	const icon =
		category === 'sport'
			? sportIconDictionary.find((sport) => sport.id === typeId)
			: racingIconDictionary.find((raceType) => raceType.id === typeId);

	return icon ? <FontIcon {...rest} iconName={icon.iconName} /> : null;
};

export default FontIcon;
